import { ProjectPostProps } from "@/type/ProjectTypes";

export default function ProjectGraph({ data }: { data: ProjectPostProps[] }) {
  const total = data.length;

  // --- 통계 계산 (Progress Bar) ---
  const nextCount = data.filter((p) =>
    p.project_meta_stack.some(
      (s) => s.project_stack.stack.toLowerCase() === "next.js"
    )
  ).length;
  const reactCount = data.filter((p) =>
    p.project_meta_stack.some(
      (s) => s.project_stack.stack.toLowerCase() === "react"
    )
  ).length;
  const etcCount = total - (nextCount + reactCount);

  return (
    <div className=" flex   gap-4  mt-4  ">
      <div className="flex gap-4  ">
        <div className="flex gap-2 items-end ">
          <span className="text-zinc-50 text-3xl">{total}</span>
          <span className="text-base border-r pr-5 border-border">total</span>
        </div>
        <div className="flex items-end gap-4 text-sm font-medium text-zinc-400 ">
          <span>
            <span className="text-zinc-50 font-semibold">{nextCount}</span>{" "}
            Next.js
          </span>
          <span>
            <span className="text-zinc-50 font-semibold">{reactCount}</span>{" "}
            React.js
          </span>
          <span>
            <span className="text-zinc-50 font-semibold">{etcCount}</span> etc
          </span>
        </div>{" "}
      </div>
    </div>
  );
}
